import { Injectable } from '@angular/core';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { SessionStorageService } from '../../../../../../core/services/session-storage/session-storage.service';
import { environment } from '../../../../../../../environments/environment';
import { inject } from '@angular/core';
import { PersonalDetailModel } from '../personal-detail-model/personal-detail-model';




@Injectable({
  providedIn: 'root'
})
export class PersonalDetailService {
  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  async savepersonalDetails(mnpersonaldetail: PersonalDetailModel) {

    const API_URL: string = environment.baseUrl + environment.apis.savemnpersonaldetail;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: mnpersonaldetail.toString()
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  // GET PERSONAL DETAILS

  async getPersonalDetails(repCode: any) {

    const API_URL: string = environment.baseUrl + environment.apis.getmnpersonaldetail;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "pias_rep_code": repCode,
        "updated_by_role": ['Director', 'NEWREP', 'Manager','DSU','DSU Manager'],
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }
}



